export default {
    config: {
        apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
        databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
        projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
        messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
    }
 //    config: {
	//   apiKey: "AIzaSyBGvF2einDFp8q3FP39q4w_8Rnn-YtSl4w",
	//   authDomain: "lojcomng.firebaseapp.com",
	//   databaseURL: "https://lojcomng.firebaseio.com",
	//   projectId: "lojcomng",
	//   storageBucket: "lojcomng.appspot.com",
	//   messagingSenderId: "229010660221",
	//   appId: "1:229010660221:web:6ec889dfbe825798ea8a14",
	//   measurementId: "G-YTPC47BKV7"
	// }
}